import { Backdrop, CircularProgress } from '@mui/material';

const Loading = () => {
  return (
    <Backdrop
      sx={(theme) => ({ bgcolor: theme.palette.success.main, zIndex: theme.zIndex.drawer + 1, opacity: '0.8 !important' })}
      open={true}
    >
      <CircularProgress color="warning" />
    </Backdrop>
  );
};

export default Loading;
